import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';

import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

export const StreamWhenSignedIn = () => {
  const client = useLDClient();
  const { currentUser } = useCurrentUserContext();
  const signedIn = !!currentUser;

  useEffect(() => {
    client?.setStreaming(signedIn);
  }, [client, signedIn]);

  return null;
};
